<template>
  <div class="album-page">
    <div class="album-title">{{ $t('albumName') }}</div>

    <div class="waterfall-container">
      <waterfall height="100%" :col="4" :data="mediaList">
        <div v-for="(item, index) in mediaList" :key="item.id || index" class="album-item" @click="openPreview(item)">
          <!-- 视频封面逻辑 -->
          <div v-if="item.type === 'video'" class="video-cover">
            <img :src="item.image || item.url" alt="cover" />
            <div class="play-icon">▶</div>
          </div>

          <!-- 图片逻辑 -->
          <img v-else :src="item.image" alt="photo" />
        </div>
      </waterfall>
      <!-- <div class="bottom-spacer" /> -->
    </div>

    <PreviewViewer v-if="previewVisible" :list="mediaList" :index="currentIndex" @close="previewVisible = false" />
  </div>
</template>

<script>
import PreviewViewer from './PreviewViewer.vue'

export default {
  components: {
    PreviewViewer
  },

  data() {
    return {
      previewVisible: false,
      currentIndex: 0,
      mediaList: [
        // {
        //   id: '1',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/1.png')
        // },
        // {
        //   id: '2',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/2.jpg')
        // },
        // {
        //   id: '3',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/3.jpg')
        // },
        // {
        //   id: '4',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/4.jpg')
        // },
        // {
        //   id: '5',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/5.jpg')
        // },
        // {
        //   id: '6',
        //   type: 'image',
        //   image: require('../../../assets/images/picsum/6.jpg')
        // },
        // {
        //   id: '7',
        //   type: 'image',
        //   url: require('../../../assets/images/picsum/7.jpg'),
        //   image: require('../../../assets/images/picsum/7.jpg')
        // },
        // {
        //   id: '8',
        //   type: 'video',
        //   image: require('../../../assets/images/picsum/8.jpg'),
        //   url: require('../../../assets/images/picsum/9.mp4')
        // }
      ]
    }
  },

  methods: {
    openPreview(item) {
      this.currentIndex = this.mediaList.findIndex((v) => v.id === item.id)
      this.previewVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.album-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 20px;
  padding-top: 0;
  height: calc(100vh - 16.75vh);
  .album-title {
    flex-shrink: 0;
    // position: sticky;
    // top: 0;
    height: 150px;
    z-index: 99;
    background: #fff;
    // padding: 30px;
    font-size: 3vw;
    line-height: 150px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
  }
}

.waterfall-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  // padding-bottom: 20px;
  box-sizing: border-box;
}

.bottom-spacer {
  height: 20px;
}

.album-item {
  cursor: pointer;
  // background-color: #fff;
  // border-radius: 8px;
  overflow: hidden;
  min-height: 100px;
  padding: 0 5px;
  &:not(:last-child) {
    margin-bottom: 16px;
  }

  img {
    width: 100%;
    display: block;
    /* 如果组件不支持自动重排，可以尝试加 min-height */
    /* min-height: 150px; */
  }
}

.video-cover {
  position: relative;
  width: 100%;
  /* 视频封面最好也定个宽高比，或者依靠图片撑开 */
}

.play-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  pointer-events: none;
}
</style>
